module.exports = __webpack_public_path__ + "img/ascend_gold28.f268683c.png";